const Paths = {
  LOGIN: 'login',
  UPDATE_PASSWORD: 'updatePassword',
  APPLICATIONS: 'applications',
  ASSETS: 'assets',
  ASSET_DETAILS: 'assetDetails',
  INTEGRATIONS: 'integrations',
  MANAGE_INTEGRATIONS: 'manage',
  RESULTS: 'results',
  TRACE_FINDINGS: 'traceFindings',
  TRACE_FINDINGS_INSIGHT: 'traceFindingsInsight',
  INQUIRY_FINDINGS: 'inquiryFindings',
  USER_MANAGEMENT: 'userManagement',
  API_KEYS: 'manageApiKeys',
  TOKEN_LEDGER: 'tokenLedger',
  COMPANY_MANAGEMENT: 'companyManagement',
  TENANT_MANAGEMENT: 'tenantManagement',
  ONAPSIS_BLOG: 'loginOnapsisBlog',
  AUDIT_LOG: 'auditLog',
  REPORTS: 'reports',
} as const;

type PathKey = (typeof Paths)[keyof typeof Paths];

export type UrlEntry = {
  path: string;
  label?: string;
  parent?: string;
};

export const urls = {
  [Paths.LOGIN]: { path: '/login' },
  [Paths.UPDATE_PASSWORD]: { path: '/update-password' },

  // feature urls
  [Paths.APPLICATIONS]: { label: 'Applications', path: '/applications' },
  [Paths.ASSETS]: { label: 'SAP', path: '/applications/sap', parent: '/applications' },
  [Paths.ASSET_DETAILS]: { path: '/asset-management/asset/:assetId' },
  [Paths.INTEGRATIONS]: { label: 'Integrations', path: '/integrations' },
  [Paths.MANAGE_INTEGRATIONS]: { label: 'Manage', path: '/integrations/manage', parent: '/integrations' },
  [Paths.RESULTS]: { label: 'Results', path: '/results' },
  [Paths.TRACE_FINDINGS]: { label: 'Investigation Results', path: '/results/:traceId', parent: '/results' },
  [Paths.TRACE_FINDINGS_INSIGHT]: {
    label: 'Insight Results',
    path: '/results/:traceId/insight/:insightId',
    parent: '/results/:traceId',
  },
  [Paths.INQUIRY_FINDINGS]: {
    label: 'Inquiry Findings',
    path: '/results/inquiry/:inquiryId',
    parent: '/results',
  },
  [Paths.USER_MANAGEMENT]: { label: 'Users', path: '/user-management' },
  [Paths.API_KEYS]: { label: 'API Keys', path: '/manage-api-keys' },
  [Paths.TOKEN_LEDGER]: { label: 'Tokens', path: '/tokens' },
  [Paths.COMPANY_MANAGEMENT]: { label: 'Companies', path: '/company-management' },
  [Paths.TENANT_MANAGEMENT]: {
    label: 'Tenants',
    path: '/company-management/:companyId',
    parent: '/company-management',
  },
  [Paths.AUDIT_LOG]: { label: 'Audit Log', path: '/audit-log' },
  [Paths.REPORTS]: { label: 'Reports', path: '/reports' },
  // external urls
  [Paths.ONAPSIS_BLOG]: { path: 'https://onapsis.com/blog' },
} satisfies Record<PathKey, UrlEntry>;
